<template>
  <transition name="fade">
    <div class="level3-landingpage-container">
      <div class="lv3-title-text">Tambah Direktur Data</div>
      <div class="lv3-edit-form" style="overflow-y: auto !important">
        <div class="edit-form-wrapper">
          <div>Jabatan</div>
          <input
            class="lv3-input-text"
            type="text"
            v-model="jabatanDirektur"
            disabled
          />
        </div>
        <div class="edit-form-wrapper">
          <div>Nama<span class="text-ast">*</span></div>
          <input
            class="lv3-input-text"
            type="text"
            v-model="namaDirektur"
            oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);"
          />
        </div>
        <div class="edit-form-wrapper">
          <div>Nomor Handphone<span class="text-ast">*</span></div>
          <div class="vendor-form">
            <!-- <input class="lv3-input-text" type="text" v-model="phoneDirektur" /> -->
            <div class="phone-add">
              <the-mask
                class="phone-add__phone"
                :mask="['+## ###################']"
                v-model="phoneDirektur"
              />
            </div>
          </div>
        </div>
        <div class="edit-form-wrapper">
          <div>Email<span class="text-ast">*</span></div>
          <input
            class="lv3-input-text"
            type="text"
            v-model="emailDirektur"
            oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);"
          />
        </div>
        <div class="edit-form-wrapper">
          <div>Upload KTP<span class="text-ast">*</span></div>
          <div class="column50">
            <label class="lv3-input-text">
              <i class="fas fa-upload"></i> <span>{{ direkturFileName }}</span>
              <input
                type="file"
                style="display: none;"
                @change="fileDirekturChangeHandler"
              />
            </label>
          </div>
        </div>
      </div>
      <div class="button-container">
        <div class="button-wrapper">
          <div class="email-button" @click="closeModal()">CANCEL</div>
          <div class="email-button" @click="submitForm()">CONFIRM</div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: ['propsData'],
  data() {
    return {
      jabatan: '',
      nama: '',
      phoneNumber: '',
      email: '',
      phoneCode: '',
    }
  },

  computed: {
    phoneDirektur: {
      get() {
        return this.$store.state.landingpage.phoneDirektur
      },
      set(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'phoneDirektur',
          value: newValue,
        })
      },
    },
    jabatanDirektur: {
      get: function() {
        if (this.$store.state.landingpage.addDirektur) {
          if (this.$store.state.landingpage.direkturList.length == 0) {
            this.$store.commit('landingpage/SET_STATE_DATA', {
              name: 'jabatanDirektur',
              value: 'DIREKTUR UTAMA',
            })
          } else {
            this.$store.commit('landingpage/SET_STATE_DATA', {
              name: 'jabatanDirektur',
              value: 'DIREKTUR',
            })
          }
        }
        return this.$store.state.landingpage.jabatanDirektur
      },
      set: function(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'jabatanDirektur',
          value: newValue,
        })
      },
    },
    namaDirektur: {
      get() {
        return this.$store.state.landingpage.namaDirektur
      },
      set(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'namaDirektur',
          value: newValue,
        })
      },
    },
    emailDirektur: {
      get() {
        return this.$store.state.landingpage.emailDirektur
      },
      set(newValue) {
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'emailDirektur',
          value: newValue,
        })
      },
    },

    direkturFileName() {
      const { direkturFiles, direkturLampiran } = this.$store.state.landingpage
      if (
        direkturFiles &&
        direkturFiles.length > 0 &&
        'name' in direkturFiles[0]
      ) {
        return direkturFiles[0].name
      }
      if (direkturLampiran) {
        return direkturLampiran
      }
      return this.labelPlaceholder
    },
  },
  methods: {
    checkForm() {
      let arr = [
        [this.namaDirektur, 'Nama Direktur'],
        [this.phoneDirektur.length > 3, 'No Telepon'],
        [
          this.isEmailValid(this.$store.state.landingpage.emailDirektur),
          'Email',
        ],
      ]

      if (!this.$get(this.$store, 'state.landingpage.direkturLampiran')) {
        arr = [
          ...arr,
          [this.$store.state.landingpage.direkturFiles.length > 0, 'KTP'],
        ]
      }

      return this.multiConditions(arr)
    },
    closeModal() {
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'addDirektur',
        value: false,
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'editDirektur',
        value: false,
      })
    },
    submitForm() {
      if (this.checkForm()) {
        this.confirm()
      }
    },
    confirm() {
      if (this.$store.state.landingpage.addDirektur) {
        let direkturData = {
          id: this.$store.state.landingpage.direkturIndex + 1,
          jabatan: this.$store.state.landingpage.jabatanDirektur,
          nama: this.$store.state.landingpage.namaDirektur,
          phoneNumber: this.$store.state.landingpage.phoneDirektur,
          email: this.$store.state.landingpage.emailDirektur,
          direkturFiles: this.$store.state.landingpage.direkturFiles,
        }

        this.$store.commit('landingpage/SET_ARRAY_DATA', {
          name: 'direkturList',
          value: direkturData,
          operation: 'add',
        })
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'direkturIndex',
          value: direkturData.id + 1,
        })
      } else if (this.$store.state.landingpage.editDirektur) {
        let direkturData = {
          id: this.$store.state.landingpage.idDirektur,
          jabatan: this.$store.state.landingpage.jabatanDirektur,
          nama: this.$store.state.landingpage.namaDirektur,
          phoneNumber: this.$store.state.landingpage.phoneDirektur,
          email: this.$store.state.landingpage.emailDirektur,
          direkturFiles: this.$store.state.landingpage.direkturFiles,
        }
        this.$store.commit('landingpage/SET_ARRAY_DATA', {
          name: 'direkturList',
          value: direkturData,
          operation: 'edit',
        })
      }

      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'jabatanDirektur',
        value: '',
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'namaDirektur',
        value: '',
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'phoneDirektur',
        value:
          this.$get(this.$store, 'state.landingpage.choosedCountry.id') == 63
            ? 62
            : '',
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'emailDirektur',
        value: '',
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'direkturFiles',
        value: [],
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'direkturLampiran',
        value: '',
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'addDirektur',
        value: false,
      })
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'editDirektur',
        value: false,
      })
    },
    fileDirekturChangeHandler(e) {
      const file = e.target.files[0];
      const maxSize = 102400

      if (file.size > maxSize) {
        this.$store.commit('SET_NOTIF', 'Ukuran file melebihi batas maksimum 100KB. Mohon unggah ulang dokumen dengan ukuran yang sesuai.')
      }
      else {
        let direkturFiles = Array.from(e.target.files)
        this.$store.commit('landingpage/SET_STATE_DATA', {
          name: 'direkturFiles',
          value: direkturFiles,
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~/assets/scss/components/login.scss';
</style>
